import { render } from "./CookieBanner.html?vue&type=template&id=2c4ffaec&scoped=true&ts=true"
import script from "./CookieBanner.ts?vue&type=script&lang=ts"
export * from "./CookieBanner.ts?vue&type=script&lang=ts"

import "./CookieBanner.css?vue&type=style&index=0&id=2c4ffaec&scoped=true&lang=css"

import exportComponent from "/home/dev/deployment/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4ffaec"]])

export default __exports__